import {Injectable} from '@angular/core';
import {BaseDataService} from '../commons/base-data.service';
import {Observable} from 'rxjs/Observable';
import {HelpersService} from '../../core/helpers/helpers.service';
import {MENU_TYPE} from './models/MENU_TYPE';
import {MenuItem} from './models/MenuItem';
import { ClientServicesService } from '../360-client-api';

@Injectable()
export class MenuDataService extends BaseDataService {
  // private menuData: { [key: string]: Array<MenuItem> } = {};
  private menuData: Array<MenuItem> = null;

  constructor(private restService: ClientServicesService,
              helpers: HelpersService) {
    super(helpers);
  }

  /*
  loadMenu(): Observable<MenuItem[]> {
    return null;
    /*
    if (this.menuData) {
      return Observable.of(this.menuData).delay(100);
    } else {
      return this.restService.getMenuItems().map(response => {
        if (response.code === 200) {
          return <MenuItem[]>response.data;
        } else {
          return <MenuItem[]>[];
        }
      });
    }
    
  }
  
  getMenu(menuType: MENU_TYPE): Observable<MenuItem[]> {
    return Observable.create((observer) => {
      this.loadMenu().subscribe(menuData => {
        const result = menuData.filter((itm) => itm.type === menuType).sort((a, b) => a.seq - b.seq);
        observer.next(result);
        observer.complete();
      }, error => {
        observer.next(null);
        observer.complete();
      });
    });
  }
  */

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/menu/menu-data.service.ts